var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_466)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.65184 2.60166C4.03752 2.57506 4.37174 2.86616 4.39834 3.25184L4.68933 7.47119L7.99415 4.01615C8.26137 3.73678 8.70448 3.72693 8.98385 3.99415C9.26323 4.26138 9.27307 4.70449 9.00585 4.98386L4.60585 9.58386C4.41425 9.78417 4.12249 9.85255 3.86184 9.75824C3.60118 9.66393 3.42073 9.4247 3.40166 9.14817L3.00166 3.34817C2.97506 2.96248 3.26615 2.62826 3.65184 2.60166Z",
    fill: "#1EA5B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2698 14.6209C10.6448 14.7147 10.8729 15.0947 10.7791 15.4698L9.27909 21.4698C9.21087 21.7426 8.98596 21.9482 8.70806 21.9916C8.43017 22.035 8.15327 21.9079 8.00506 21.6689L4.90506 16.6689C4.70135 16.3403 4.80256 15.9088 5.13113 15.7051C5.45971 15.5014 5.89121 15.6026 6.09492 15.9311L8.32246 19.5239L9.42089 15.1302C9.51466 14.7552 9.89471 14.5271 10.2698 14.6209Z",
    fill: "#1EA5B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9006 13.2073C16.2831 13.2628 16.5483 13.618 16.4927 14.0006L15.5927 20.2006C15.5537 20.4695 15.3625 20.6916 15.1023 20.7701C14.8421 20.8487 14.56 20.7695 14.3786 20.5671L10.0786 15.7671C9.82066 15.4791 9.84497 15.0366 10.1329 14.7786C10.4209 14.5207 10.8634 14.545 11.1214 14.8329L14.4223 18.5177L15.1073 13.7994C15.1628 13.4168 15.518 13.1517 15.9006 13.2073Z",
    fill: "#F37261"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81385 4.02521C9.18653 3.9224 9.57198 4.14117 9.67479 4.51385L10.9032 8.96679L13.8468 5.17102C14.0838 4.86553 14.5235 4.80993 14.829 5.04685C15.1345 5.28376 15.1901 5.72348 14.9532 6.02898L11.1532 10.929C10.9908 11.1383 10.7241 11.2381 10.4642 11.1867C10.2043 11.1353 9.99566 10.9416 9.9252 10.6862L8.3252 4.88615C8.22239 4.51347 8.44117 4.12801 8.81385 4.02521Z",
    fill: "#F37261"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9898 5.13231C15.3586 5.01622 15.7516 5.22105 15.8677 5.5898L17.0986 9.49981L19.3987 5.64156C19.5967 5.30949 20.0264 5.20078 20.3584 5.39874C20.6905 5.5967 20.7992 6.02638 20.6013 6.35845L17.5013 11.5584C17.36 11.7954 17.0928 11.9273 16.8188 11.8953C16.5448 11.8633 16.3151 11.6733 16.2323 11.4102L14.5323 6.0102C14.4162 5.64145 14.621 5.2484 14.9898 5.13231Z",
    fill: "#1EA5B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3115 11.5001C21.698 11.5064 22.0062 11.8249 21.9999 12.2115L21.8999 18.3115C21.8953 18.5896 21.7265 18.8387 21.4698 18.9459C21.213 19.0531 20.9172 18.9982 20.7161 18.8059L16.1161 14.4059C15.8368 14.1386 15.8269 13.6955 16.0941 13.4161C16.3614 13.1368 16.8045 13.1269 17.0839 13.3942L20.5263 16.687L20.6001 12.1885C20.6064 11.802 20.9249 11.4938 21.3115 11.5001Z",
    fill: "#1EA5B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03886 2.47004C2.16587 2.10489 2.56483 1.91185 2.92997 2.03885C5.18974 2.82486 7.55498 3.41723 10.0503 4.0162C13.5028 4.70565 17.5611 5.10238 20.9411 5.30121C21.327 5.32391 21.6215 5.65517 21.5988 6.04111C21.5761 6.42704 21.2448 6.72149 20.8589 6.69879C17.4432 6.49787 13.3074 6.09535 9.76273 5.38641C9.754 5.38466 9.7453 5.38275 9.73665 5.38067C7.23681 4.78071 4.80634 4.17377 2.47004 3.36115C2.1049 3.23414 1.91185 2.83518 2.03886 2.47004Z",
    fill: "#1EA5B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7554 11.4542C22.8912 11.8162 22.7078 12.2197 22.3458 12.3554C19.1316 13.5608 15.199 14.8726 11.656 15.6824L11.6373 15.6864C9.12391 16.1891 6.69415 16.5947 4.15582 16.7978C3.77045 16.8286 3.43306 16.5412 3.40223 16.1558C3.3714 15.7705 3.65881 15.4331 4.04418 15.4022C6.50275 15.2055 8.87012 14.8119 11.3533 14.3155C14.808 13.5251 18.6713 12.2382 21.8542 11.0446C22.2162 10.9088 22.6197 11.0922 22.7554 11.4542Z",
    fill: "#1EA5B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/party.0050a7f1f5a0d66e765f04db0a6253d3.svg";
export { ForwardRef as ReactComponent };